import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer id="contact" className="footer">
      <div className="container">
        <div className="footer-cta">
          <h2 className="footer-title">Everyone is selling AI. We make it real.</h2>
          <p className="footer-subtitle">We hold a small number of companies at a time. It begins with a week: an engineer inside your business, a live map, and a radar of what to build next.</p>
          <div className="footer-buttons">
            <a href="https://app.nanocaps.ai/signup" className="primary-button">
              <img 
                src="https://hzmsjouaorxtdfjrfvrz.supabase.co/storage/v1/object/public/Assets/sound.png" 
                alt="Sound icon" 
                className="button-icon"
              />
              Book a Call
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">© 2026 Nanocaps. All rights reserved.</p>
          <div className="footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

